import { Typography } from "@mui/material";
import React from "react";
const GroupRepresentation = ({
  groupRepresentationTabel,
  setGroupRepresentationTabel,
}) => {
  const handleInputChange = (rowIndex, field, value) => {
    const updatedData = { ...groupRepresentationTabel };
    updatedData[rowIndex][field] = value;
    setGroupRepresentationTabel(updatedData);
  };
  console.log("I am called");
  const nameMap = {
    executiveManagement: "Executive Management",
    nonExecutiveManagement: "Non - Executive Management",
    professionals: "Professionals",
    allOtherEmployees: "All Other Employees",
  };
  return (
    <div>
      {/* Table Container */}
      <div
        style={{
          marginTop: "20px",
          border: "1px solid #000",
          borderRadius: "8px",
          overflow: "hidden",
          width: "100%",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr
              style={{
                backgroundColor: "#D3C9CE",
                color: "#000",
                fontWeight: "bold",
                textAlign: "left",
              }}
            >
              <th style={tableHeaderStyle}></th>
              <th style={tableHeaderStyle}>Group A</th>
              <th style={tableHeaderStyle}>Group B</th>
              <th style={tableHeaderStyle}>Group C</th>
              <th style={tableHeaderStyle}>NA</th>
            </tr>
          </thead>
          <tbody>
            {[
              "executiveManagement",
              "nonExecutiveManagement",
              "professionals",
              "allOtherEmployees",
            ].map((row, index) => (
              <tr key={index}>
                <td style={tableCellStyle}>
                  <Typography>{nameMap[row]}</Typography>
                </td>
                {["groupA", "groupB", "groupC", "NA"].map((field) => (
                  <td key={field} style={tableCellStyle}>
                    <input
                      type="number"
                      value={groupRepresentationTabel[row][field]}
                      onChange={(e) =>
                        handleInputChange(row, field, e.target.value)
                      }
                      style={inputFieldStyle}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputFieldStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey", // Thin light grey border
  color: "grey", // Grey text color
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
  // fontWeight: "bold",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey", // Thin light grey border
  color: "grey", // Grey text color
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
  // fontWeight: "bold",
};

export default GroupRepresentation;
